import { makeStyles } from 'tss-react/mui';

export const styles = makeStyles()((theme) => ({
  table: {
    minWidth: 700,
    'tr:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  rowContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  tableHeader: {
    width: '100%',
    padding: '20px 0 20px 0',
    display: 'flex',
    justifyContent: 'space-between',
  },
  footer: {
    width: '100%',
  },
  operationContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  operationBtn: {
    color: 'blue',
    cursor: 'pointer',
    textDecoration: 'underline',
    fontSize: '0.85rem',
    whiteSpace: 'nowrap',
  },
  disabled: {
    color: '#BBBBBB',
    cursor: 'default',
  },
  link: {
    textDecoration: 'underline',
  },
}));
